module.exports = __webpack_public_path__ + "static/media/0_2019_03_08.a381881c.jpg";